<template>
  <div class="category">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>分类名称：</span>
      <el-input v-model="list.cateName" placeholder="请输入分类名称"></el-input>
      <el-button type="primary" @click="getCategroy()">查找</el-button>
      <el-button
        type="primary"
        @click="onAdd"
        v-if="$store.state.powerList.indexOf('card:type:list:add') !== -1"
        >添加</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column
        v-if="$store.state.powerList.indexOf('card:type:list:update') !== -1"
        header-align="center"
        align="center"
        prop="dept"
        label="排序"
      >
        <template slot-scope="{ row }">
          <el-input
            class="input-new-tag"
            v-if="row.inputVisible"
            v-model="row.dept"
            ref="saveTagInput"
            size="small"
            @input="onInput"
            @keyup.enter.native="handleInputConfirm(row)"
            @blur="handleInputConfirm(row)"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="onChangeSort(row)"
            >{{ row.dept }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="cateId"
        label="分类ID"
        width="width"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="cateName"
        label="分类名称"
        width="width"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="cateImg"
        label="分类图片"
        width="width"
      >
        <template slot-scope="{ row }">
          <el-image
            style="width: 80px; height: 80px"
            :src="row.cateImg"
            :preview-src-list="[row.cateImg]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="strStatus"
        label="状态"
        width="width"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="width">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            size="mini"
            @click="onDelRow(row.cateId, 1)"
            v-if="
              row.status === 2 &&
              $store.state.powerList.indexOf('card:type:list:update') !== -1
            "
            >上架</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="onDelRow(row.cateId, 2)"
            v-if="
              row.status === 1 &&
              $store.state.powerList.indexOf('card:type:list:update') !== -1
            "
            >下架</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="$store.state.powerList.indexOf('card:type:list:add') !== -1"
            @click="onEdit(row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="
              $store.state.powerList.indexOf('card:type:list:update') !== -1
            "
            @click="onDelRow(row.cateId, 0)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="list.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 添加一级分类 -->
    <el-dialog
      destroy-on-close
      :title="addOrEdit.cateId === 0 ? '添加分类' : '编辑分类'"
      :visible.sync="addDialogVisible"
      width="30%"
      @close="onDiaLog"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="分类名称">
          <el-input
            placeholder="请输入要添加的分类名称"
            v-model="addOrEdit.cateName"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类图片">
          <send-image
            v-if="addDialogVisible"
            :images="addOrEdit.cateImg"
            @addImageStr="addImageStr"
          ></send-image>
        </el-form-item>
        <el-form-item label=""> 建议尺寸265*123px </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditCateOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  category,
  addOrEditCategory,
  changeSort,
  changeStatus,
} from "../../api/wanlvCard";
import { sendFile } from "../../api/sendFile";
import sendImage from "../../components/sendImage.vue";
export default {
  components: { sendImage },
  name: "category",
  data() {
    return {
      addDialogVisible: false,
      tableData: [],
      list: {
        pageSize: 5,
        currentPage: 1,
        cateName: "",
      },
      pagination: {},
      addOrEdit: {
        cateId: null,
        cateName: null,
        cateImg: null,
      },
    };
  },
  created() {
    this.getCategroy();
  },
  methods: {
    //删除
    onDelRow(cateId, status) {
      this.$confirm("是否设置这条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await changeStatus({
            cateId,
            status,
          });
          if (data.code === 0) {
            this.$message({
              message: data.msg,
              type: "success",
            });
            this.getCategroy();
          } else {
            this.$message({
              message: data.msg,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onEdit(row) {
      this.addOrEdit.cateImg = row.cateImg;
      this.addOrEdit.cateId = row.cateId;
      this.addOrEdit.cateName = row.cateName;
      this.addDialogVisible = true;
    },
    onDiaLog() {
      this.addOrEdit.cateImg = null;
      this.addOrEdit.cateId = null;
      this.addOrEdit.cateName = null;
    },
    onAdd() {
      this.addDialogVisible = true;
      this.addOrEdit.cateId = 0;
    },
    async getCategroy() {
      const { data } = await category(this.list);
      if (data.code === 0) {
        data.list.map((item) => {
          item.inputVisible = false;
        });
        this.tableData = data.list;
        this.pagination = data.pagination;
      } else {
        this.$message.error(data.msg);
      }
    },
    onChangeSort(row) {
      row.inputVisible = true;
    },
    async handleInputConfirm(row) {
      const { data } = await changeSort({
        cateId: row.cateId,
        dept: Number(row.dept),
      });
      if (data.code !== 0) {
        this.$message({
          message: data.msg,
          type: "error",
        });
      } else {
        this.$message({
          message: data.msg,
          type: "success",
        });
      }
      row.inputVisible = false;
    },
    //添加一级分类
    async onEditCateOk() {
      if (!this.addOrEdit.cateName || !this.addOrEdit.cateImg) {
        return this.$message({
          message: "请把数据填写完整！",
          type: "warning",
        });
      }
      const { data } = await addOrEditCategory(this.addOrEdit);
      if (data.code == 0) {
        this.$message({
          message: data.msg,
          type: "success",
        });
        this.getCategroy();
      } else {
        this.$message({
          message: data.msg,
          type: "error",
        });
      }
      this.addDialogVisible = false;
      this.addOrEdit.cateId = null;
      this.addOrEdit.cateName = null;
      this.addOrEdit.cateImg = null;
    },
    onInput(value) {
      var reg = /^[0-9]*[1-9][0-9]*$/;
      var reg2 = /^-[0-9]*[1-9][0-9]*$/;
      if (!reg.test(value) && !reg2.test(value)) {
        return this.$message({
          type: "warning",
          message: "请输入整数!",
        });
      }
    },
    sendAvatar() {
      this.$refs.fileRef.click();
    },
    addImageStr(image) {
      this.addOrEdit.cateImg = image;
    },
    async onFileChange(event) {
      // 根据这个 <input> 获取文件的 HTML5 js 对象
      var files = event.target.files;
      if (files && files.length > 0) {
        // 获取目前上传的文件
        var file = files[0];
        var formData = new FormData();
        formData.append("file", file);
        const { data } = await sendFile(formData);

        this.addOrEdit.cateImg = data.data[0].src;
      }
    },
    handleSizeChange(num) {
      this.list.pageSize = num;
      this.getCategroy();
    },
    handleCurrentChange(num) {
      this.list.currentPage = num;
      this.getCategroy();
    },
  },
};
</script>
<style lang="less" scoped>
.category {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    .el-select {
      margin: 0 20px;
    }
    .select {
      margin: 0 10px;
    }
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
  .el-table {
    margin-top: 50px;
  }
  .el-pagination {
    float: right;
    margin-top: 50px;
  }
  /deep/.el-form {
    .el-form-item {
      .el-form-item__content {
        .elbtn {
          margin-left: 10px;
          background-color: unset;
          width: 110px;
          height: 110px;
          text-align: center;
          line-height: 110px;
          color: #000;
          border: 1px solid #ccc;
        }
        display: flex;
        .img {
          position: relative;
          margin: 0 20px;
          height: 100px;
          width: 100px;
          img {
            height: 100px;
            width: 100px;
            border: 1px solid #c0ccda;
          }
          div {
            position: absolute;
            top: 0;
            right: 5px;
            height: 10px;
            width: 10px;
            z-index: 100;
          }
        }
        .addImg {
          display: inline-block;
          width: 100px;
          height: 100px;
          border: 1px dashed #c0ccda;
          text-align: center;
          line-height: 100px;
          cursor: pointer;
          i {
            width: 50px;
            height: 50px;
            font-size: 20px;
            color: #c0ccda;
          }
        }
        span {
          margin-left: 30px;
          color: red;
        }
      }
    }
  }
}
</style>